import { Component, Input } from '@angular/core';
import { Endereco } from 'src/app/api';

@Component({
  selector: 'mandae-display-address',
  templateUrl: './display-address.component.html',
  styleUrls: ['./display-address.component.scss']
})
export class DisplayAddressComponent {

  @Input()
  public address: Partial<Endereco>;

  public get firstLine(): string {
    if (!this.address) {
      return '';
    }

    const parts = [this.address.logradouro, this.address.numero, this.address.complemento];
    return parts.filter(part => !!part).join(', ');
  }

}
